import { UseQueryOptions } from 'react-query';
import { ServiceError } from '../../../../../hooks/error';
import { useCustomMutate, useCustomQuery } from '../../../../../hooks/query';
import { getCandidateParticular, putCandidateParticular } from '../api-services/api';
import { CandidateProfileResponse } from '../models';
import { CANDIDATE_KEY_GET_PARTICULAR, CANDIDATE_KEY_UPDATE_PARTICULAR } from './keys';

/** react query to update candidate particular
 * @param successCallback
 * @param failCallback
 * @param csrfToken
 * */
export const useUpdateCandidateParticular = (onSuccess: any, onError: any) =>
  useCustomMutate<any, any>(
    [CANDIDATE_KEY_UPDATE_PARTICULAR],
    putCandidateParticular,
    {
      onSuccess,
      onError,
    },
    false,
    false
  );

/** to get candidate particular
 * @param queryOptions
 * */
export const useGetCandidateParticular = (
  queryOptions?: UseQueryOptions<CandidateProfileResponse, ServiceError, CandidateProfileResponse>
) =>
  useCustomQuery<CandidateProfileResponse>(
    [CANDIDATE_KEY_GET_PARTICULAR],
    () => getCandidateParticular().then((res) => res.data),
    queryOptions
  );
